import React from 'react';
import PropTypes from 'prop-types';

const Ratings = (props) => {
	const { ratings, ratingScale, prefs } = props;
	if (!ratings) {
		return null;
	}
	const { overallRatingPadding, overallRatingBgColor, useInverseTextColor } =
		prefs;
	const textColor = useInverseTextColor === 'true' ? 'text-inverse' : '';
	const textMutedColor =
		useInverseTextColor === 'true' ? 'text-muted-inverse' : 'text-muted';

	return (
		<div className="kbb-ratings ml-auto">
			<div
				className={`${overallRatingBgColor} border ddc-font-size-small text-center ${overallRatingPadding}`.trim()}
			>
				<span className={textMutedColor}>Overall</span>
				<strong
					className={`ddc-font-size-xxlarge d-block font-weight-bold ${textColor}`.trim()}
				>
					{ratings[0].value}
				</strong>
				<span className={textMutedColor}>Out of {ratingScale}</span>
			</div>
		</div>
	);
};

Ratings.propTypes = {
	ratings: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired
		})
	).isRequired,
	ratingScale: PropTypes.number.isRequired,
	prefs: PropTypes.shape({
		overallRatingPadding: PropTypes.string,
		overallRatingBgColor: PropTypes.string,
		useInverseTextColor: PropTypes.string
	}).isRequired
};

export default Ratings;
